(function () {
  'use strict';

  function parseRate(raw) {
    if (raw == null || raw === '') return 0;
    const n = parseFloat(String(raw).trim().replace(',', '.'));
    return Number.isFinite(n) && n > 0 ? n : 0;
  }

  function calcParcelCents(priceCents, installments, ratePercent) {
    const n = Math.max(2, parseInt(installments, 10) || 2);
    const price = Math.max(0, parseInt(priceCents, 10) || 0);
    if (ratePercent <= 0) {
      return { installments: n, parcelCents: Math.round(price / n), hasInterest: false };
    }
    const total = price * (1 + ratePercent / 100);
    return { installments: n, parcelCents: Math.round(total / n), hasInterest: true };
  }

  function formatAmount(cents) {
    if (typeof formatMoney === 'function' && window.MinimogSettings?.money_format) {
      return formatMoney(cents, window.MinimogSettings.money_format);
    }
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function renderHtml(n, amount, hasInterest) {
    const suffix = hasInterest ? ' no cartão' : ' sem juros';
    return (
      'em até <span class="jv-parcelamento-pdp__emph">' +
      n +
      'x</span> de <span class="jv-parcelamento-pdp__emph">' +
      amount +
      '</span>' +
      suffix
    );
  }

  function updateEl(el) {
    const textNode = el.querySelector('[data-jv-parcelamento-text]');
    if (!textNode) return;

    const rate = parseRate(el.dataset.rateRaw);
    const { installments: n, parcelCents, hasInterest } = calcParcelCents(
      el.dataset.price,
      el.dataset.installments,
      rate
    );
    const amount = formatAmount(parcelCents);
    textNode.innerHTML = renderHtml(n, amount, hasInterest);
  }

  function bindWrapper(el) {
    if (el.dataset.parcelamentoBound === '1') return;
    el.dataset.parcelamentoBound = '1';
    updateEl(el);
  }

  function onVariantChange(e) {
    const variant = e?.data?.variant;
    if (!variant) return;
    document.querySelectorAll('[data-jv-parcelamento-pdp]').forEach((el) => {
      el.dataset.price = String(variant.price);
      updateEl(el);
    });
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-jv-parcelamento-pdp]').forEach(bindWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.variantChange) {
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, onVariantChange);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) init(event.target);
  });
})();
